import { DEFAULT_SESSION_COOKIE_MINUTES, DEFAULT_USER_COOKIE_MAX_AGE_DAYS } from "@/constants";

export type GlobalConfigAttributes = {
    readonly userCookieMaxAgeDays: number;
    readonly sessionCookieMaxAgeMinutes: number;
};
export const getGlobalConfig = ():GlobalConfigAttributes => {
    const cookieConfig =
    {
        userCookieMaxAgeDays: Number(process.env.NEXT_PUBLIC_USER_COOKIE_MAX_AGE_DAYS ?? DEFAULT_USER_COOKIE_MAX_AGE_DAYS ?? 30),
        sessionCookieMaxAgeMinutes: Number(process.env.NEXT_PUBLIC_SESSION_COOKIE_MAX_AGE_MINUTES ?? DEFAULT_SESSION_COOKIE_MINUTES  ?? 120),      
    }
    return cookieConfig;
};
